// extracted by mini-css-extract-plugin
module.exports = {"blogItem":"blog_excerpt-module--blog-item--wKGs_","blogDate":"blog_excerpt-module--blog-date--2HGU7","blogTitle":"blog_excerpt-module--blog-title--3KxRR"};